import React from 'react';

import { cn } from '../../lib/utils';

type EstimateSelectorItemStatusTagProps = {
  status?: string | null;
  className?: string;
};

const getStatusToneClassName = (status: string) => {
  if (status.toLowerCase() === 'rejected') {
    return 'border-red-200 bg-red-50 text-red-700';
  }

  return 'border-slate-200 bg-slate-50 text-slate-600';
};

export const EstimateSelectorItemStatusTag = ({
  status,
  className,
}: EstimateSelectorItemStatusTagProps) => {
  const label = String(status || '').trim();
  if (!label) return null;

  return (
    <span
      data-qa="estimate-selector-item-status"
      aria-label={`Item status: ${label}`}
      title={`Item status: ${label}`}
      className={cn(
        'inline-flex max-w-[120px] items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold leading-none',
        'overflow-hidden text-ellipsis whitespace-nowrap',
        getStatusToneClassName(label),
        className
      )}
    >
      {label}
    </span>
  );
};
